import { useEffect, useState } from "react";
import { api, API_URL, fmtDate } from "@/lib/api";
import { FlaskConical, FileText } from "lucide-react";

export default function PortalDocuments() {
  const [docs, setDocs] = useState(null);
  useEffect(() => { api.get("/portal/documents").then((r) => setDocs(r.data)).catch(() => {}); }, []);
  return (
    <div className="space-y-4" data-testid="portal-documents">
      <h1 className="text-2xl font-display font-bold text-slate-900 tracking-tight">Documents</h1>
      <div className="bg-white border border-slate-200 rounded-xl p-5">
        <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-slate-500 font-semibold mb-3">
          <FlaskConical size={13} className="text-[#FC5F5F]" /> Test Certificates & Reports</div>
        <div className="divide-y divide-slate-100">
          {(docs?.certificates || []).map((c) => (
            <div key={c.id} className="flex flex-wrap items-center gap-3 py-2.5 text-[13px]">
              <span className="font-mono text-xs font-semibold text-slate-900">{c.number}</span>
              <span className="text-slate-700">{c.product}</span>
              {c.invoice_no && <span className="text-xs text-slate-400">Invoice: {c.invoice_no}</span>}
              <span className="text-xs text-slate-400">{fmtDate(c.date)}</span>
              <a href={`${API_URL}/portal/certificates/${c.id}/pdf`} target="_blank" rel="noreferrer"
                 className="ml-auto inline-flex items-center gap-1 text-xs border border-slate-200 rounded-md px-3 py-1.5 text-slate-600 hover:border-slate-400" data-testid={`pd-cert-${c.id}`}>
                <FileText size={12} /> Download</a>
            </div>
          ))}
          {docs && docs.certificates.length === 0 && <p className="text-sm text-slate-400 py-6 text-center">No documents available yet.</p>}
        </div>
      </div>
      <p className="text-[11px] text-slate-400">Need a COA, datasheet or material certificate? Raise a request from the Support tab.</p>
    </div>
  );
}
